import request from '../utils/request1'
import Vue from 'vue'
export function getApi(url,params,successFunction,failFunction) {
	return request({
    url: url,
    method: 'get',
    params: params
  }).then(function(request){
  	if(request.data.code == 0){
  		  successFunction(request.data);
    	}else{
    		failFunction(request.data);
    	}
  })
}


export function postApi(url,params,successFunction,failFunction) {
	return request({
    url: url,
    method: 'post',
    data: params
  }).then(function(request){
  	if(request.data.code == 0){
  			successFunction(request.data);
    	}else{
    		failFunction(request.data);
    	}
   })
}

export function commonApi(url,method,responseType,params,successFunction,failFunction) {
	if(responseType == null || responseType == undefined){
		responseType = 'application/json'
	}
	return request({
    url: url,
    method: method,
		responseType: responseType,
    data: params
  }).then(function(request){
  	if(request.data.code == 0){
  			successFunction(request.data);
    	}else{
    		failFunction(request.data);
    	}
   })
}
export function getMessage(value,type){
	// Vue.prototype.$message=ELEMENT.Message
	Vue.prototype.$message({
          message: value,
          type:type
        });
}
export function downloadApi(url,method,responseType,params,successFunction) {
	if(responseType == null || responseType == undefined){
		responseType = 'application/json'
	}
	return request({
    url: url,
    method: method,
		responseType: responseType,
    data: params
  }).then(function(request){
		successFunction(request.data);
//   	if(request.data.code == 0){
//   			successFunction(request.data);
//     	}else{
//     		failFunction(request.data);
//     	}
   })
}



// WEBPACK FOOTER //
// ./src/api/commonApi.js